import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { isChunkLoadError, reloadForStaleChunk } from './lib/chunk-reload';
import './styles/tokens.css';
import './styles/app.css';
import './styles/mobile.css';
import './styles/utilities.css';

// Stale-chunk recovery (see src/lib/chunk-reload.ts). Two non-render paths the
// route ErrorBoundary can't see:
//   - vite:preloadError — Vite's chunk-preload fetch failed.
//   - unhandledrejection — a background route preload (App.tsx warms screens for
//     the signed-in role) rejected with a failed dynamic import.
// Both mean this tab is running against an old deploy; reload once to refresh.
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault();
  reloadForStaleChunk();
});
window.addEventListener('unhandledrejection', (e) => {
  if (isChunkLoadError(e.reason)) {
    e.preventDefault();
    reloadForStaleChunk();
  }
});

const root = document.getElementById('app');
if (!root) throw new Error('#app not found');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
